import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { RegisterAccountGroupsShareRequestModel, RegisterAccountGroupsShareResponseModel } from "@/features/accounts/account-group/services/register-account-groups-share-model";

export class RegisterAccountGroupsShareApi {
  /**
   * 口座グループ共有メンバー登録
   */
  public registerAccountGroupsShare = async (
    param: RegisterAccountGroupsShareRequestModel
  ): Promise<RegisterAccountGroupsShareResponseModel> => {
    const path = `/api/accountgroups/share`;
    const res = await ApiClient.instance.post<RegisterAccountGroupsShareResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
